export interface ISubmissionCardTabPanelProps {
  children?: React.ReactNode;
  label?: string;
  active?: boolean;
}

export function SubmissionCardTabPanel(props: ISubmissionCardTabPanelProps) {
  const { children, label, active } = props;

  return (
    <div
      role="tabpanel"
      aria-label={label}
      tabIndex={active ? 0 : -1}
      aria-hidden={!active}
    >
      {children}
    </div>
  );
}
